
import {Injectable} from '@angular/core';
import {App} from 'ionic-angular';
import {StorageService} from './storageservice';

import {LoginPage} from '../../pages/login/login/login';

/**
 * LoginFilter  判断是否登陆，如果没有登陆则跳到登陆界面
 * @description
 */
@Injectable()
export class LoginFilter {
  constructor(private appCtrl :App) {
  }
  
  //判断是否已经登陆
  isLogin(){
  	var currentUser = StorageService.getObj("currentUser");
  	if(currentUser&&currentUser.userId!=null&&currentUser.userId!='undefined'&&currentUser.userId!=''){
  		return true;
  	}
  	return false;
  }
  //判断是否未登陆跳转到LoginPage
  isToLogin(){
  	if(!this.isLogin()){
  		this.appCtrl.getRootNav().push(LoginPage);
  	}
  }
  
  
  
}



// WEBPACK FOOTER //
// ./src/providers/service/loginfilter.ts